import { Component, OnInit, Input } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { Template } from '../masterdata/models/template';
import { MachineType } from '../masterdata/models/machineType';
import { Printer } from '../masterdata/models/printer';
import { SelectableProcessStep } from '../masterdata/models/SelectableProcessStep';
import { ProcessStep } from '../masterdata/models/processStep-enum';
import { CarrierState } from '../masterdata/models/carrierState';
import { MdmProcessStepService } from './mdm-process-step.service';

@Component({
  selector: 'app-mdm-process-step',
  templateUrl: './mdm-process-step.component.html',
  styleUrls: ['./mdm-process-step.component.css']
})
export class MdmProcessStepComponent implements OnInit {

  @Input() masterLists: CarrierState[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() processStepOptions: SelectableProcessStep[];
  @Input() labOptions: LabMDM[];
  @Input() machineTypesOptions: MachineType[];
  @Input() printerOptions: Printer[];
  @Input() templateOptions: Template[];
  
  isNewMasterList: boolean;
  popupTitle: string;
  masterList: CarrierState;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: any;
  isProcessStepName:string = "name";
  isLab: string = "lab";
  isProcessStepMachineType: string = "machineType";
  isProcessStepPrinter: string = "printer";
  isDefaultTemplate: string = "defaultTemplate";
  isNextStep: string = "nextStep";
  isProcessList:string = "processList";
  isPlatePrefix:string = "platePrefixes"
  isExtraField1: string = "extraField1";
  isInputCheck1: string = "inputCheck1";
  isExtraField2: string = "extraField2";
  isInputCheck2: string = "inputCheck2";
  isActive: string = "active";

  selectedLabName: string;
  selectedLab: LabMDM;
  selectedMachineTypeName: string;
  selectedMachineType: MachineType;
  selectedPrinterName: string;
  selectedPrinter: Printer;
  selectedTemplateName: string;
  selectedTemplate: Template;
  extraField1: string;
  inputCheck1: string;
  extraField2: string;
  inputCheck2: string;
  platePrefixes: string;

  selectedProcessStep: SelectableProcessStep;
  nextProcessStep: SelectableProcessStep;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, 
    private _msdmProcessStepService: MdmProcessStepService) { }

  ngOnInit() {
    this.popupTitle = this.title;
  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.getProcessStep(this.masterList.name);
    this.getActiveOptionsForDropdowns();
    this.platePrefixes = this.masterList.platePrefixes;
    this.extraField1 = this.masterList.extraField1;
    this.inputCheck1 = this.masterList.inputCheck1;
    this.extraField2 = this.masterList.extraField2;
    this.inputCheck2 = this.masterList.inputCheck2;
  }

  //Get the Process Step by Enum selection
  getProcessStep(processStep: string) {
    switch (processStep) {
      case "SAMPLE_RECEPTION": {
        this.selectedProcessStep = { label: ProcessStep.SAMPLE_RECEPTION, processStep: ProcessStep.SAMPLE_RECEPTION }
        break;
      }
      case "MERGING": {
        this.selectedProcessStep = { label: ProcessStep.MERGING, processStep: ProcessStep.MERGING }
        break;
      }
      case "REACTION_MIX": {
        this.selectedProcessStep = { label: ProcessStep.REACTION_MIX, processStep: ProcessStep.REACTION_MIX }
        break;
      }
      case "THERMAL_CYCLER": {
        this.selectedProcessStep = { label: ProcessStep.THERMAL_CYCLER, processStep: ProcessStep.THERMAL_CYCLER }
        break;
      }
      case "DT_REMOVAL": {
        this.selectedProcessStep = { label: ProcessStep.DT_REMOVAL, processStep: ProcessStep.DT_REMOVAL }
        break;
      }
      case "SPLITTING": {
        this.selectedProcessStep = { label: ProcessStep.SPLITTING, processStep: ProcessStep.SPLITTING }
        break;
      }
      case "SEQUENCING": {
        this.selectedProcessStep = { label: ProcessStep.SEQUENCING, processStep: ProcessStep.SEQUENCING }
        break;
      }
      case "PREPARING": {
        this.selectedProcessStep = { label: ProcessStep.PREPARING, processStep: ProcessStep.PREPARING }
        break;
      }
      case "REACTIONS_PLACEMENT": {
        this.selectedProcessStep = { label: ProcessStep.REACTIONS_PLACEMENT, processStep: ProcessStep.REACTIONS_PLACEMENT }
        break;
      }
      case "ENTRY_QC": {
        this.selectedProcessStep = { label: ProcessStep.ENTRY_QC, processStep: ProcessStep.ENTRY_QC }
        break;
      }
      case "EXTRACTION": {
        this.selectedProcessStep = { label: ProcessStep.EXTRACTION, processStep: ProcessStep.EXTRACTION }
        break;
      }
      case "ENTRY_QC_OK": {
        this.selectedProcessStep = { label: ProcessStep.ENTRY_QC_OK, processStep: ProcessStep.ENTRY_QC_OK }
        break;
      }
      case "LIB_PREP_START": {
        this.selectedProcessStep = { label: ProcessStep.LIB_PREP_START, processStep: ProcessStep.LIB_PREP_START }
        break;
      }
      case "ENRICHMENT": {
        this.selectedProcessStep = { label: ProcessStep.ENRICHMENT, processStep: ProcessStep.ENRICHMENT }
        break;
      }
      case "FRAGMENTATION": {
        this.selectedProcessStep = { label: ProcessStep.FRAGMENTATION, processStep: ProcessStep.FRAGMENTATION }
        break;
      }
      case "CDNA_SYNTHESIS": {
        this.selectedProcessStep = { label: ProcessStep.CDNA_SYNTHESIS, processStep: ProcessStep.CDNA_SYNTHESIS }
        break;
      }
      case "END_REPAIR": {
        this.selectedProcessStep = { label: ProcessStep.END_REPAIR, processStep: ProcessStep.END_REPAIR }
        break;
      }
      case "AMPLIFICATION": {
        this.selectedProcessStep = { label: ProcessStep.AMPLIFICATION, processStep: ProcessStep.AMPLIFICATION }
        break;
      }
      case "LIB_QC": {
        this.selectedProcessStep = { label: ProcessStep.LIB_QC, processStep: ProcessStep.LIB_QC }
        break;
      }
      case "LIB_PREP_COMPLETE": {
        this.selectedProcessStep = { label: ProcessStep.LIB_PREP_COMPLETE, processStep: ProcessStep.LIB_PREP_COMPLETE }
        break;
      }
      

    }
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    //Get Active Labs for Lab Drop down
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;

        //Get the Lab details inside asynchornus call
        // and get drop down details for seleceted lab
        this.getDropDetailsBySelectedLab();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    //Get the next Step from Master List
    if(this.masterList.nextStep){
      this.nextProcessStep = { label: this.masterList.nextStep, processStep: this.masterList.nextStep};
    }
    else{
      this.nextProcessStep = null;
    }
  }

  //Get Dropdown data by the selected Lab
  getDropDetailsBySelectedLab(){
    this.machineTypesOptions = [];
    this.printerOptions = [];
    this.templateOptions = [];

    if(this.selectedLab){
      //Get Active Machine Types for Machine Type Drop down
      this._msdmProcessStepService.getMachineTypesByLab(this.selectedLab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Active machine types:", results.data);
          this.machineTypesOptions = results.data;
            this.machineTypesOptions.forEach(type => {
              if (this.masterList && this.masterList.machineType && type._id == this.masterList.machineType._id) {
                this.selectedMachineTypeName = this.masterList.machineType.name;
                this.selectedMachineType = type;
              }
            })
            if (!this.masterList || !this.masterList.machineType || this.selectedMachineTypeName != this.masterList.machineType.name)
              this.selectedMachineType = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      //Get Active Printers for Printer Drop down
      this._msdmProcessStepService.getPrintersByLab(this.selectedLab,true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Active printers:", results.data);
          this.printerOptions = results.data;
          this.printerOptions.forEach(printer => {
            if (this.masterList && this.masterList.printer && printer._id == this.masterList.printer._id) {
              this.selectedPrinterName = this.masterList.printer.name;
              this.selectedPrinter = printer;
            }
          })
          if (!this.masterList || !this.masterList.printer || this.selectedPrinterName != this.masterList.printer.name)
            this.selectedPrinter = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );

      //Get Active Templates for Template Drop down
      this._msdmProcessStepService.getTemplatesByLab(this.selectedLab, true).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Active templates:", results.data);
          this.templateOptions = results.data;
          this.templateOptions.forEach(template => {
            if (this.masterList && this.masterList.defaultTemplate && template.templateName == this.masterList.defaultTemplate.templateName) {
              this.selectedTemplateName = this.masterList.defaultTemplate.templateName;
              this.selectedTemplate = template;
            }
          })
          if (!this.masterList || !this.masterList.defaultTemplate || this.selectedTemplateName != this.masterList.defaultTemplate.templateName)
            this.selectedTemplate = null;
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(message);
        }
      );
    }
  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new CarrierState();
    this.displayMasterListDialog = true;
    this.selectedLab = null;
    this.getActiveOptionsForDropdowns();
    this.selectedProcessStep = null;
    this.platePrefixes = null;
    this.extraField1 = null;
    this.inputCheck1 = null;
    this.extraField2 = null;
    this.inputCheck2 = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];

    this.masterList.name = this.selectedProcessStep.processStep;
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.machineType = new MachineType();
    this.masterList.machineType = this.selectedMachineType;
    this.masterList.printer = new Printer();
    this.masterList.printer = this.selectedPrinter;
    this.masterList.defaultTemplate = new Template();
    this.masterList.defaultTemplate = this.selectedTemplate;
    if(this.nextProcessStep){
      this.masterList.nextStep = this.nextProcessStep.processStep;
    }
    else{
      this.masterList.nextStep = null;
    }
    this.masterList.platePrefixes = this.platePrefixes;
    this.masterList.extraField1 = this.extraField1;
    this.masterList.inputCheck1 = this.inputCheck1;
    this.masterList.extraField2 = this.extraField2;
    this.masterList.inputCheck2 = this.inputCheck2;

    console.log("masterList:", this.masterList);

    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: CarrierState[]) {
    this._masterDataService.addCarrierState(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        console.log("carrierState:", results.data);
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        this.displayMasterListDialog = true;
      }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: CarrierState[]) {
    this._masterDataService.updateCarrierState(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("carrierState:", results.data);
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        this.displayMasterListDialog = true;
      }
    );
  }

  //Check if the Template Name or Lab is Entered or not, if not disable Save button
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    if (!this.selectedLab || !this.selectedProcessStep || !this.selectedPrinter || !this.selectedMachineType)
      return true;
    return false;
  }

  //Disable the field depending on Extra Field1
  isInputCheck1Disabled(){
    if(this.extraField1 && this.extraField1.trim() != "")
    {
      return false;
    }
    else{
      this.inputCheck1 = null;
      return true;
    }
  }

  //Disable the field depending on Extra Field2
  isInputCheck2Disabled(){
    if(this.extraField2 && this.extraField2.trim() != "")
    {
      return false;
    }
    else{
      this.inputCheck2 = null;
      return true;
    }
  }

}
